module.exports = __webpack_public_path__ + "img/stamp_partners.592c0954.png";